<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="7rem"
        :destroy-on-close="true"
        :show-close="false"
        :close-on-click-modal="false"
        custom-class="address-dialog"
        @close="handleClose">
        <div slot="title" class="l-dialog-title">
            收货信息
        </div>
        <el-form ref="formRef" :model="formParams" :rules="formRules" label-width="1rem" class="address-form">
            <el-form-item label="收货人" prop="name">
                <el-input v-model="formParams.name" placeholder="请输入收货人" class="form-field"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="formParams.phone" placeholder="请输入手机号" class="form-field"></el-input>
            </el-form-item>
            <el-form-item label="所在地区" prop="region">
                <el-cascader class="form-field" v-model="formParams.region" :options="regionData">
                </el-cascader>
            </el-form-item>
            <el-form-item label="收货地址" prop="address">
                <el-input v-model="formParams.address" placeholder="请填写收货地址" type="textarea" class="form-field"></el-input>
            </el-form-item>
        </el-form>
        <label class="checkbox-label" :class="{'shaking': needAnimate}">
            <input type="checkbox" v-model="isConfirm" />
            请您认真核对邮寄地址，我们会按照以上地址为您邮寄资料，谢谢您的配合！
        </label>
        <div slot="footer" class="l-dialog-btn-box">
                <el-button class="l-dialog-btn-confirm" :class="{'disable': !isConfirm}" @click="onSubmit">
                    确认地址
                </el-button>
            <!-- <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit">确 定</el-button> -->
        </div>
    </el-dialog>
</template>

<script>
import { Dialog, Form, FormItem, Input, Cascader, Button } from 'element-ui'
import { apiGetTemplateData } from '@/models/cms'

export default {
    name: 'DialogAddress',
    components: {
        ElDialog: Dialog,
        ElForm: Form,
        ElFormItem: FormItem,
        ElInput: Input,
        ElCascader: Cascader,
        ElButton: Button,
    },
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
        form: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            formParams: {},
            regionKeyValue: {},
            formRules: {
                name: [{
                    required: true, message: '请填写收货人姓名', trigger: 'blur'
                }],
                phone: [{
                    required: true, message: '请填写手机号', trigger: 'blur', pattern: /^1[3456789]\d{9}$/
                }],
                region: [{
                    required: true, message: '请选择所在地区', trigger: 'blur'
                }],
                address: [{
                    required: true, message: '请填写收货地址', trigger: 'blur'
                }],
            },
            needAnimate: false,
            isConfirm: false,
            regionData: [],
        }
    },
    computed: {
        dialogVisible: {
            get () {
                return this.visible;
            },
            set (value) {
                this.$emit('update:visible', value);
            }
        },
    },
    watch: {
        form (newVal, oldVal) {
            if (newVal !== oldVal) {
                // const region = addressData.code.split('-').map((item, index) => JSON.stringify([Number(item), addressData.codeName.split(' ')[index]]))
                const region = newVal.addressCode ? newVal.addressCode.split('-').map((item) => Number(item)) : ''
                this.formParams = {
                    id: newVal.id,
                    name: newVal.recipient,
                    phone: newVal.phone,
                    address: newVal.addressDetail,
                    region,
                    codeName: newVal.addressCodeName,
                }
            }
        }
    },
    methods: {
        async onSubmit () {
            if (!this.isConfirm) {
                this.needAnimate = true
                setTimeout(() => {
                    this.needAnimate = false
                }, 1000)
                return
            }
            const valid = await this.$refs.formRef.validate()
            if (!valid) return
            this.dialogVisible = false
            const params = this.generateParams()
            this.$emit('confirm', params)
        },
        handleClose () {
            this.formParams = {}
        },
        fetchRegionData () {
            apiGetTemplateData({
                name: '全国地区行政区规代码'
            }).then(res => {
                const data = res.data.map(item => ({ ...item.data }))
                this.regionData = this.transformData(data)
            })
        },
        transformData (data) {
            return data.map(item => {
                const transformedItem = {
                    value: item.i, // JSON.stringify([item.i, item.n]),
                    label: item.n,
                    children: null
                };
                this.regionKeyValue[item.i] = item.n
                if (item.c && item.c.length > 0) {
                    transformedItem.children = this.transformData(item.c);
                }

                return transformedItem;
            });
        },
        generateParams () {
            const params = {
                userId: this.formParams.id,
                recipient: this.formParams.name,
                phone: this.formParams.phone,
                addressDetail: this.formParams.address,
                addressCode: this.formParams.region.join('-'),
                addressCodeName: this.formParams.region.map(key => this.regionKeyValue[key]).join(' '),
            }

            return params
        }
    },
    created () {
        this.fetchRegionData()
    },
}
</script>

<style scoped>
.el-dialog__wrapper >>> .address-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    padding: 40px 0 80px;
    box-shadow: none;
    background: url('../../../components/l-dialog/images/l-bg-dialog.png?x-oss-process=image/interlace,1') no-repeat center;
    background-size: 100% 100%;
}

.el-dialog__wrapper >>> .el-dialog__header {
    padding: 0;
}
.l-dialog-title {
    padding-top: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #fa9300;
    -webkit-text-stroke: 1px rgba(255, 255, 255, 0.8);
}

.address-form >>> .el-form-item__label {
    color: #fff;
    font-size: 16px;
}
.form-field {
    width: 320px;
    font-size: 16px;
}
.checkbox-label {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    width: 400px;
    margin-bottom: 20px;
    color: #feb664;
    font-size: 18px;
    text-align: left
}
.checkbox-label.shaking {
    animation: shake ease-out 0.5s;
}
@keyframes shake {
    0% { transform: translateX(0); }
    25% { transform: translateX(-8px); }
    50% { transform: translateX(8px); }
    75% { transform: translateX(-8px); }
    100% { transform: translateX(0); }
}

.el-dialog__wrapper >>> .el-dialog__footer {
    padding: 0;
}
.l-dialog-btn-box {
    text-align: center;
}
.l-dialog-btn-box > button {
    display: block;
    width: 160px;
    height: 55px;
    border: none;
    color: #EA741B;
    font-size: 16px;
}
.l-dialog-btn-confirm {
    margin-top: -30px;
    background: url('../../../components/l-dialog/images/l-bg-yellow.png') no-repeat;
    background-size: 100%;
}
.l-dialog-btn-confirm.disable {
    background: url('../../../components/l-dialog/images/l-bg-gray.png') no-repeat;
    background-size: 100%;
}
</style>
